import React from 'react';
import {RiRobot3Line} from "react-icons/ri";

function parseText(text) {
    console.log(text)

    const parts = text.split("\n");

    return parts.map((part, index) => (<p>{part}</p>))

}


export function AIResponse({message}) {

  if(message == null ) return null

    return (
        <div className={"explain-box "}>
            <div className={"explain-header"}>
                <h5 className={"m-0 p-0 fw-bold"}>KARAKTERBOOST-KI</h5>
            </div>
            <div className={"explain-text"}>
                {
                    parseText(message.content)
                }
            </div>

        </div>
    );

}